/**
 * Scenario ID lists typed or pasted into the config form.
 */

/**
 * The IDs in pasted text: split on commas and whitespace (spaces, tabs, newlines),
 * so a column copied from Excel or a comma list pastes as-is. Quotes around an ID
 * (a SQL IN list, a Python list) are dropped.
 */
export const parseScenarioList = (text) =>
  String(text ?? '')
    .split(/[\s,]+/)
    .map((token) => token.replace(/^['"]+|['"]+$/g, ''))
    .filter(Boolean);

/**
 * Matches pasted IDs to the IDs available for the as-of date, ignoring case (a run
 * upper-cases SCEN_IDS). `known` holds the available spelling of each match and
 * `unknown` each unmatched ID as pasted, both in pasted order and without repeats.
 */
export const matchScenarioIds = (tokens, available) => {
  const byKey = new Map(available.map((id) => [String(id).toUpperCase(), id]));
  const seen = new Set();
  const known = [];
  const unknown = [];
  tokens.forEach((token) => {
    const key = token.toUpperCase();
    if (seen.has(key)) return;
    seen.add(key);
    if (byKey.has(key)) known.push(byKey.get(key));
    else unknown.push(token);
  });
  return { known, unknown };
};

/** The current selection followed by each added ID it does not already hold. */
export const mergeScenarioIds = (current, added) => {
  const merged = [...current];
  const held = new Set(current);
  added.forEach((id) => {
    if (!held.has(id)) {
      held.add(id);
      merged.push(id);
    }
  });
  return merged;
};
